import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import {
  EShopSystem,
  ShopConfigData,
} from '@/core/apis/config_api/config_api_types';
import { ConfigApi } from '@/core/apis/config_api/index';

import { RecacheStorageHandler } from '../storage_handler_cached';
import { ShopConfigHandler } from './config_handler';

// Refactored ShopConfigDataHandler
export class ShopConfigDataHandler {
  private static readonly _storageHandler =
    new RecacheStorageHandler<ShopConfigData>(
      'shopConfig',
      {
        active: false,
        config: {
          script_tag_worker_retry_enabled: false,
          script_tag_wtag_retry_enabled: false,
        },
        destinations: [],
        sourceType: EShopSystem.ABSENT,
        uid: '',
      },
      EBrowserStorageType.LOCALSTORAGE, // Set the storage provider
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      1 * 30 * 1000, // 30 seconds
      // eslint-disable-next-line @typescript-eslint/unbound-method
      ConfigApi.get,
    );

  static async initOrLoad(
    localConfig: Partial<ShopConfigData>,
  ): Promise<ShopConfigHandler> {
    const cachedData = await this._storageHandler.getAsync();
    if (localConfig?.config || localConfig?.customEvents) {
      if (localConfig.config) {
        cachedData.config = { ...localConfig.config, ...cachedData.config };
      }
      if (localConfig.customEvents) {
        cachedData.customEvents = localConfig.customEvents.concat(
          cachedData.customEvents,
        );
      }
      this._storageHandler.set(cachedData);
    }
    return new ShopConfigHandler(cachedData);
  }

  // synchronously returns the current config - might not be fetched during call
  static getCurrentConfig() {
    return this._storageHandler.get().data;
  }
}
